import type {
  TopicFetchContentMetaAction,
  TopicFetchContentMetaFailureAction,
  TopicFetchContentMetaSuccessAction,
} from "domains/topicSearchFilter/actionTypes";
import { TopicContentMetaTypes } from "domains/topicSearchFilter/actionTypes";

export const fetchTopicContentMeta = (): TopicFetchContentMetaAction => ({
  type: TopicContentMetaTypes.FETCH_CONTENT_META,
});

export const fetchTopicContentMetaSuccess = (
  payload: TopicFetchContentMetaSuccessAction["payload"],
): TopicFetchContentMetaSuccessAction => ({
  type: TopicContentMetaTypes.FETCH_CONTENT_META_SUCCESS,
  payload,
});

export const fetchTopicContentMetaFailure = (
  meta: TopicFetchContentMetaFailureAction["meta"],
): TopicFetchContentMetaFailureAction => ({
  type: TopicContentMetaTypes.FETCH_CONTENT_META_FAILURE,
  meta,
});
